import { useState } from 'react'
import { Filter, Trash } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent } from '../../ui/dialog'
import {
  InfluencerData,
  InfluencerTableFilters,
} from '../../../core/interface/chronique.interface'
import InfluencerTableViewContainer from './InfluencerTableViewContainer'

import { Button } from '../../ui/button'
import { TableViewTypeInfluencerEnum } from '../../../core/enums/table-view-type-influencer.enum'
import { InfluencerFilterYesNoEnum } from '../../../core/enums/influencer-filter.enum'
import ChroniquerProgressBar from '../shared/ChroniquerProgressBar'

interface Props {
  open: boolean
  onClose: () => void
  data: InfluencerData[]
  onValidate: (selectedUsers: InfluencerData[]) => void
  loading: boolean
}

const InfluencerTableViewModal = ({
  open,
  onClose,
  data,
  onValidate,
  loading,
}: Props) => {
  const { t } = useTranslation()
  const [selectedUsers, setSelectedUsers] = useState<InfluencerData[]>([])
  const [userSelected, setUserSelected] = useState<InfluencerData | null>(null)
  const [showFilters, setShowFilters] = useState(true)
  const [headerFilters, setHeaderFilters] = useState<InfluencerTableFilters>({
    selection: [],
    status: [],
    alreadyInfluenced: [InfluencerFilterYesNoEnum.NO],
  })

  const handleResetFiltersAndSelections = () => {
    setSelectedUsers([])
    setUserSelected(null)
    setShowFilters(false)
    setHeaderFilters({
      selection: [],
      status: [],
      alreadyInfluenced: [],
      chronique: [],
      complete: [],
      promise: [],
    })
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[95vw] max-h-[95vh] px-0 pb-0 pt-4">
        <ChroniquerProgressBar currentStep={2} completedSteps={[1]} />
        <div className="bg-[#3B3B3B]">
          <div className="px-6 py-4 text-white bg-[#3B3B3B]">
            <div className="flex items-center justify-between">
              <div className="flex flex-col items-start">
                <h1 className="text-xl font-semibold">
                  {t('chroniqueurView.importingAudience')}
                </h1>
                <h2 className="text-lg">
                  {t('chroniqueurView.selectedInfluencers')}
                </h2>
              </div>
              <div className="flex gap-2 items-center text-sm">
                {t(
                  selectedUsers.length > 1
                    ? 'chroniqueurView.influencerSelected_other'
                    : 'chroniqueurView.influencerSelected_one',
                  {
                    count: selectedUsers.length,
                  },
                )}
                <Button
                  variant="default"
                  onClick={() => setShowFilters(!showFilters)}
                  className="ml-4 bg-[#666] hover:bg-[#777] text-white"
                  size="icon"
                >
                  <Filter className="h-4 w-4 text-white" />
                </Button>
                <Button
                  variant="destructive"
                  size="icon"
                  onClick={() => {
                    handleResetFiltersAndSelections()
                  }}
                  className="ml-2 bg-red-600 hover:bg-red-700 text-white"
                >
                  <Trash className="h-4 w-4 text-white" />
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-col h-[70vh] overflow-auto">
            <InfluencerTableViewContainer
              viewType={TableViewTypeInfluencerEnum.NEW_CHRONIQUEUR_VIEW}
              data={data}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              userSelected={userSelected}
              setUserSelected={setUserSelected}
              showFilters={showFilters}
              onValidate={onValidate}
              headerFilters={headerFilters}
              setHeaderFilters={setHeaderFilters}
              loading={loading}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default InfluencerTableViewModal
